export default __webpack_public_path__ + "static/media/ps51.14e0eea6.png";